import React, { useEffect, useState } from "react";
import ForgetPassModal from "../../Common/Modal/ForgetPassModal/ForgetPassModal";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as API from "../../Utils/Services/api";
import { jwtDecode } from "jwt-decode";
import { getCurrentUserRole } from "./CondoAdminNavbar";

const CondoAdminLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [isVisible, setIsVisible] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });

  // useEffect(() => {
  //   if (!localStorage.getItem("admin_data")) {
  //     localStorage.setItem("admin_data", JSON.stringify(dummy_admin_token));
  //   }
  //   if (localStorage.getItem("admin_token")) {
  //     navigate("/condoDashboard");
  //   }
  // }, [navigate]);

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.role === "ADMIN") {
          navigate("/condoDashboard");
        }
      } catch (error) {
        console.error("ERROR", error);
      }
    }
  }, [navigate]);

  // const onSubmit = (data) => {
  //   setIsLoading(true);
  //   setLoginError("");

  //   const storedAdmin = JSON.parse(localStorage.getItem("admin_data"));

  //   if (!storedAdmin) {
  //     setLoginError("No admin exists. Please set up an admin.");
  //     setIsLoading(false);
  //     return;
  //   }

  //   if (
  //     // data.username === storedAdmin.username &&
  //     data.email.toLowerCase() === storedAdmin.email.toLowerCase() &&
  //     data.password === storedAdmin.password
  //   ) {
  //     localStorage.setItem("admin_token", "dummy_admin_token");
  //     toast.success("Login successful!");
  //     navigate("/condoDashboard");
  //   } else {
  //     setLoginError("Invalid credentials. Please try again.");
  //   }

  //   setIsLoading(false);
  // };

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      setLoginError("");

      const response = await API.AdminLoginAPI(data);

      if (response.status === 200) {
        localStorage.setItem("admin_token", response.data.token);
        setIsLoading(false);
        const userRole = getCurrentUserRole();
        if (userRole === "SUPERADMIN") {
          toast.success("SuperAdmin Login Successfull");
          navigate("/condoDashboard");
        }
        if (userRole === "ADMIN") {
          toast.success("Admin Login Successfull");
          navigate("/condoDashboard");
        }
      }
    } catch (error) {
      if (error.response) {
        setLoginError(error.response.data.message || "Login failed.");
        toast.error("Error Occured. Try again later");
        setIsLoading(false);
      } else {
        setIsLoading(false);
        toast.error("Error Occured. Try again later");
        setLoginError("An error occurred. Please try again.");
      }
      console.error("Login error:", error);
    }
  };
  const onPreview = () => {
    setIsVisible(!isVisible);
  };
  const inputHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="admin-dashboard-main-pg">
      <div className="container-fluid" style={{ padding: 0 }}>
        <div className="login-pg">
          <div
            className="navbar-brand"
            style={{
              backgroundColor: " #7ccafd",
              borderBottom: " 3px solid #0b9afa4d",
            }}
          >
            <a className="header-logo-main-login-page" href="/">
              <img
                src="	https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png"
                alt="logo"
                style={{ width: "60px" }}
              />
            </a>
          </div>
          <div className="container">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="login-form">
                <h4>ADMIN LOGIN</h4>

                {loginError && (
                  <p style={{ color: "red", marginBottom: "10px" }}>
                    {loginError}
                  </p>
                )}

                <div className="login-form-details mt-4">
                  {/* Username */}
                  {/* <div className="email-credentials">
                    <p className="pb-2">USERNAME</p>
                    <input
                      type="text"
                      placeholder="Username"
                      {...register("username", {
                        required: "Username is required",
                        pattern: {
                          value: /^[a-zA-Z0-9_]+$/,
                          message:
                            "Username must not contain spaces or special characters",
                        },
                      })}
                    />
                    {errors.username && (
                      <p style={{ color: "red" }}>{errors.username.message}</p>
                    )}
                  </div> */}

                  {/* Email */}
                  <div className="email-credentials">
                    <p className="pb-2">EMAIL</p>
                    <input
                      type="text"
                      placeholder="Email Address"
                      name="email"
                      onChange={inputHandler}
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Enter a valid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <p style={{ color: "red" }}>{errors.email.message}</p>
                    )}
                  </div>

                  {/* Password */}
                  <div className="password-credentials">
                    <div className="forgot-password">
                      <p className="pb-2">PASSWORD</p>
                      {/* <div className="forgot-password-modal">
                        <button
                          type="button"
                          className="forgot-pass pb-2"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                        >
                          Forgot password?
                        </button>
                      </div> */}
                    </div>
                    <div className="input-container">
                      <input
                        type={isVisible ? "text" : "password"}
                        onChange={inputHandler}
                        placeholder="Password"
                        className="input-with-icon"
                        name="password"
                        {...register("password", {
                          required: "Password is required",
                          minLength: {
                            value: 8,
                            message:
                              "Password must be at least 8 characters long",
                          },
                        })}
                      />
                      <i
                        className={`fa-solid ${
                          isVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                        onClick={onPreview}
                      ></i>
                    </div>
                    {errors.password && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "small",
                          letterSpacing: "2.4px",
                        }}
                      >
                        {errors.password.message}
                      </p>
                    )}
                  </div>

                  {/* Submit */}
                  <div className="sign-up-btn">
                    <button type="submit" disabled={isLoading}>
                      {isLoading ? "Logging in..." : "LOGIN "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* <ForgetPassModal /> */}
      </div>
    </div>
  );
};

export default CondoAdminLogin;
